import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForgotPasswordMutation } from '../store/authApi';
import toast from 'react-hot-toast';
import AuthLayout from './AuthLayout';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await forgotPassword({ email }).unwrap();
      setSent(true);
      toast.success('Reset link sent if the email is registered.');
    } catch (error: any) {
      toast.error(error?.data?.message || 'Something went wrong');
    }
  };

  return (
    <AuthLayout isLogin>
      <h2 className="font-display font-extrabold text-3xl text-trident-gray-900 mb-2">Reset password</h2>
      <p className="text-trident-gray-500 mb-8">
        Enter your email and we'll send you a link to reset your password.
      </p>

      {sent ? (
        <div className="card bg-green-50 border-green-200 mb-6">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-full bg-green-100 text-green-600 flex items-center justify-center flex-shrink-0">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <div>
              <div className="font-display font-bold text-green-900 mb-1">Check your inbox</div>
              <p className="text-sm text-green-700">If an account exists for <strong>{email}</strong>, a reset link has been sent. Please check your email (and spam folder).</p>
            </div>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-xs font-display font-semibold text-trident-gray-600 uppercase tracking-wider mb-1.5">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-field"
              placeholder="you@example.com"
              required
            />
          </div>
          <button type="submit" disabled={isLoading} className="btn-primary w-full justify-center flex items-center gap-2 py-3">
            {isLoading ? 'Sending...' : 'Send reset link'}
          </button>
        </form>
      )}

      <div className="mt-6 text-center">
        <Link to="/login" className="text-sm font-display font-semibold text-trident-gray-600 hover:text-trident-orange transition-colors">
          ← Back to sign in
        </Link>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
